/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Foxit_PlatformsInputs */

const en_pc_alt_t_foxit_platforms = /** @type {(inputs: Pc_Alt_T_Foxit_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows, macOS; mobile apps on higher plans`)
};

const zh_pc_alt_t_foxit_platforms = /** @type {(inputs: Pc_Alt_T_Foxit_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows、macOS；较高档套餐含移动应用`)
};

/**
* | output |
* | --- |
* | "Windows, macOS; mobile apps on higher plans" |
*
* @param {Pc_Alt_T_Foxit_PlatformsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_foxit_platforms = /** @type {((inputs?: Pc_Alt_T_Foxit_PlatformsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Foxit_PlatformsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_foxit_platforms(inputs)
	return zh_pc_alt_t_foxit_platforms(inputs)
});
export { pc_alt_t_foxit_platforms as "pc.alt.t.foxit.platforms" }